import React from 'react'

export const BnbBooking = () => {
  return (
    <div>BnbBooking</div>
  )
}
